const api_url = function () {
    return "https://api.amrutcup.org";
}

export const API_URL = api_url();


// WEBPACK FOOTER //
// ./src/components/Constants.js